module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dt-portland-600.287db8ece68737eb.png"+" 600w",
        images: [{path: "https://static.sniffspot.com/packs/img/dt-portland-600.287db8ece68737eb.png",width: 600,height: 450}],
        src: "https://static.sniffspot.com/packs/img/dt-portland-600.287db8ece68737eb.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/dt-portland-600.287db8ece68737eb.png"},
        
        width: 600,
        height: 450
      }